import type { FeedbackGetPayload, FeedbackSelect } from '@erikdakoda/database/types';

export const FeedbackForEditSelect = {
  id: true,
  ownerId: true,
  type: true,
  title: true,
  description: true,
  pageUrl: true,
  stepsToReproduce: true,
  screenshotIds: true,
  submittedAt: true,
  readAt: true,
  closedAt: true,
  notes: true,
  aiMessageId: true,
  toolCallId: true,
} satisfies FeedbackSelect;

export type FeedbackForEdit = FeedbackGetPayload<{
  select: typeof FeedbackForEditSelect;
}>;
